import {normalizedType, Normalizer} from "./normalizer";
import {CmrDocument} from "../../model/CmrDocument";

const CmrDocumentNormalizer = new class implements Normalizer<CmrDocument> {
    normalize(data: normalizedType<CmrDocument>): CmrDocument {
        const doc = new CmrDocument(
            data.filename ?? '',
            data.uploadedBy,
            data.createdAt ? new Date(data.createdAt) : new Date(),
            data.updatedAt ? new Date(data.updatedAt) : new Date(),
        );
        doc.id = data.id ?? null;
        return doc;
    }
}();

export {CmrDocumentNormalizer};
